import { Users } from 'lucide-react'
import { useUser } from '../contexts/UserContext'
import { Navigate } from 'react-router-dom'

const VolunteersPage = () => {
  const { user, isAuthenticated } = useUser()

  // Redirect volunteers away from this page
  if (isAuthenticated && user?.userType === 'VOLUNTEER') {
    return <Navigate to="/" replace />
  }

  // Redirect non-authenticated users to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Food banks, suppliers, and admins can view volunteers
  if (
    isAuthenticated &&
    user?.userType !== 'FOOD_BANK' &&
    user?.userType !== 'SUPPLIER' &&
    user?.userType !== 'ADMIN'
  ) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Volunteers</h1>
          <p className="text-gray-600">Connect with dedicated volunteers in your community.</p>
        </div>

        {/* Empty State */}
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">Volunteer listings will appear here.</p>
        </div>
      </div>
    </div>
  )
}

export default VolunteersPage 